import React from 'react';
import { Chip } from '@mui/material';
import type { AlertStatus } from 'components/shared/utils/colorUtils';

interface EventStatusBadgeProps {
  status: AlertStatus;
  size?: 'small' | 'medium';
}

/**
 * Color map for event statuses:
 *  - new          -> blue   (primary.main)
 *  - acknowledged -> grey   (grey.500)
 *  - dismissed    -> green  (success.main)
 *  - promoted     -> info   (info.main)
 */
const STATUS_COLORS: Record<AlertStatus, { bg: string; text: string }> = {
  new: { bg: 'primary.main', text: 'common.white' },
  acknowledged: { bg: 'grey.500', text: 'common.white' },
  dismissed: { bg: 'success.main', text: 'common.white' },
  promoted: { bg: 'info.main', text: 'common.white' },
};

const STATUS_LABELS: Record<AlertStatus, string> = {
  new: 'New',
  acknowledged: 'Acknowledged',
  dismissed: 'Dismissed',
  promoted: 'Promoted',
};

/**
 * Simple colored badge for event statuses (no icons).
 * Follows the same pattern as IncidentStatusBadge.
 */
function EventStatusBadge({ status, size = 'small' }: EventStatusBadgeProps) {
  const colors = STATUS_COLORS[status] || STATUS_COLORS.new;

  return (
    <Chip
      label={STATUS_LABELS[status] || status.charAt(0).toUpperCase() + status.slice(1)}
      size={size}
      sx={{
        bgcolor: colors.bg,
        color: colors.text,
        fontWeight: 'bold',
        fontSize: size === 'small' ? '0.7rem' : '0.8rem',
      }}
    />
  );
}

export default EventStatusBadge;
